//import React, { Component } from 'react';
import ReactDOM from "react-dom";
//import { check, set } from "./StyleProperty.js";
import BrowserPropertyValidator from "./StyleProperty.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import Controller from "../../../pages/viewer-dashboard/section/studyBrowserSection/controller/index";
import _ from "lodash";
import Cache from "core/cache";
import Helper from "helper/index";

const cloneElement = (element, targetId) => {
  // Clone the DOM element
  const clone = element.cloneNode(true);

  // Find any canvas children to clone
  //const clonedCanvases = $(clone).find('canvas');
  const domNode = ReactDOM.findDOMNode(clone);
  const clonedCanvases = domNode.querySelectorAll("canvas");

  clonedCanvases.forEach((clonedCanvas, canvasIndex) => {
    // Draw from the original canvas to the cloned canvas
    const context = clonedCanvas.getContext("2d");
    const domNode = ReactDOM.findDOMNode(element);
    const thumbnailCanvas = domNode.querySelectorAll("canvas")[canvasIndex];

    context.drawImage(thumbnailCanvas, 0, 0);
  });

  // Update the clone with the targetId
  clone.id = targetId;
  clone.style.visibility = "hidden";

  return clone;
};

//const thumbnailDragStartHandler = (event, data, ) => {
const thumbnailDragStartHandler = (event, data, object) => {
  // Prevent any scrolling behaviour normally caused by the original event
  //event.originalEvent.preventDefault();
  event.preventDefault();

  // Identify the current study and series index from the thumbnail's DOM position
  const targetThumbnail = event.currentTarget;
  const imageThumbnailNode = ReactDOM.findDOMNode(targetThumbnail);
  //const headerNode = document.getElementsByClassName('studyBrowser')[0];

  // Force to hardware acceleration to move element
  // if browser supports translate property
  let propValidator = new BrowserPropertyValidator();
  const useTransform = propValidator.check("transform", "translate(1px, 1px)");

  // Clone the image thumbnail
  const targetId = "DragClone";
  const clone = cloneElement(targetThumbnail, targetId);
  const cloneNode = ReactDOM.findDOMNode(clone);
  cloneNode.classList.add("imageThumbnailClone");
  //cloneNode.addClass('imageThumbnailClone');

  // Set pointerEvents to pass through the clone DOM element
  // This is necessary in order to identify what is below it
  // when using document.elementFromPoint
  clone.style.pointerEvents = "none";

  // Append the clone to the body
  document.body.appendChild(clone);

  // Set the cursor x and y positions from the current touch/mouse coordinates
  // cursorX,Y screen coordinate
  let cursorX;
  let cursorY;

  // 마우스/터치 이벤트가 발생한 좌표를 획득한다. 아래 cursorX/Y 좌표는 브라우저 상에서 x,y 좌표이며
  // 브라우저 왼쪽 위 구석이 (0, 0) 좌표를 갖는다.
  if (event.type === "touchstart") {
    // 터치 이벤트일 경우.
    cursorX = event.touches[0].pageX;
    cursorY = event.touches[0].pageY;
  } else {
    // 마우스 이벤트일 경우.
    cursorX = event.pageX;
    cursorY = event.pageY;

    // Also hook up event handlers for mouse events
    const handlers = {};
    handlers.mousemove = (event) => thumbnailDragHandler(event, object);
    handlers.mouseup = (event) =>
      thumbnailDragEndHandler(event, data, handlers, object);

    //const documentNode = ReactDOM.findDOMNode(clone);
    document.addEventListener("mousemove", handlers.mousemove);
    document.addEventListener("mouseup", handlers.mouseup);
    // imageThumbnailNode.addEventListener('mousemove', handlers.mousemove)
    // imageThumbnailNode.addEventListener('mouseup', handlers.mouseup)
  }

  // This block gets the current offset of the touch/mouse
  // relative to the window
  //
  // i.e. Where did the user grab it from?
  //const offset = imageThumbnailNode.offset();
  //const { left, top } = offset;
  // const offsetLeft = imageThumbnailNode.offsetLeft;
  /// getBoundingClientRect 는 element의 Page 좌표를 반환한다.
  /// 페이지 좌표는 브라우저에서 표시되는 페이지의 왼쪽,위 구석을 (0,0) 으로 한다.
  /// 하지만, element의 좌표/너비/높이 값은 box-sizing property에 따라 달라진다.
  /// border-box로 설정된 경우, client의 좌표계산에는
  /// margin을 제외한 border+padding+content이 포함된다.
  /// content-box의 경우는 오직 content 길이만 포함된다.
  /// 그러므로, getBoundingClientRect 함수 사용시 이를 주의해야한다.(이는 getClientRect도 동일하다.)
  // const offsetTop =
  //   imageThumbnailNode.getBoundingClientRect().top -
  //   imageThumbnailNode.clientHeight;
  let element = document.querySelector(".toolbarSection");
  var style = element.currentStyle || window.getComputedStyle(element),
    //height = element.offsetHeight, // or use style.width
    margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
  const offsetTop =
    imageThumbnailNode.getBoundingClientRect().top -
    //imageThumbnailNode.getClientRects()[0].y -
    imageThumbnailNode.clientHeight +
    margin +
    3;
  const offsetLeft = imageThumbnailNode.getBoundingClientRect().left;

  // offsetLeft/Top is different with getBoundingClientRect
  // offsetLeftTop is relative with parent element, but
  // getBoundingClientRect return browser coordinate(start point is page top/left point)

  // This difference is saved for later so the element movement looks normal
  const diff = {
    x: cursorX - offsetLeft,
    y: cursorY - offsetTop,
  };
  cloneNode.dataset.diff_x = diff.x;
  cloneNode.dataset.diff_y = diff.y;

  cloneNode.style.visibility = "hidden";
  cloneNode.style.zIndex = 100000;

  // This sets the default style properties of the cloned element so it is
  // ready to be dragged around the page
  if (useTransform) {
    const viewNode = document.getElementById("viewerMain");
    const viewerHeight = viewNode.clientHeight;
    const heightDiff = viewerHeight;

    const positionX = cursorX - diff.x;
    const positionY = cursorY - diff.y - heightDiff;

    cloneNode.dataset.heightDiff = heightDiff;
    const translation = `translate(${positionX}px, ${positionY}px)`;
    let propValidator = new BrowserPropertyValidator();
    propValidator.set(cloneNode, "transform", translation);
  } else {
    cloneNode.style.left = cursorX - diff.x;
    cloneNode.style.position = "fixed";
    cloneNode.style.top = cursorY - diff.y;
  }
};

const thumbnailDragHandler = (event, object) => {
  // Get the touch/mouse coordinates from the event
  let cursorX;
  let cursorY;
  if (event.type === "touchmove") {
    cursorX = event.changedTouches[0].pageX;
    cursorY = event.changedTouches[0].pageY;
  } else {
    cursorX = event.pageX;
    cursorY = event.pageY;
  }

  // Find the clone element and update it's position on the page
  //const targetThumbnail = event.currentTarget;
  const cloneNode = document.getElementById("DragClone");

  //const cloneNode = domElement.querySelector('#DragClone')
  const diff = {
    x: cloneNode.dataset.diff_x,
    y: cloneNode.dataset.diff_y,
  };

  // Force to hardware acceleration to move element
  // if browser supports translate property
  let propValidator = new BrowserPropertyValidator();
  const useTransform = propValidator.check("transform", "translate(1px, 1px)");

  cloneNode.style.visibility = "visible";
  cloneNode.style.zIndex = 100000;

  // This sets the default style properties of the cloned element so it is
  // ready to be dragged around the page
  if (useTransform) {
    const heightDiff = cloneNode.dataset.heightDiff; //data('heightDiff');
    const positionX = cursorX - diff.x;
    const positionY = cursorY - diff.y - heightDiff;

    //const positionY = -100;
    //const positionY = cursorY - diff.y - heightDiff;
    //const positionY = cursorY - diff.y - heightDiff;

    const translation = `translate(${positionX}px, ${positionY}px)`;
    let propValidator = new BrowserPropertyValidator();
    propValidator.set(cloneNode, "transform", translation);
  } else {
    cloneNode.style.left = cursorX - diff.x;
    cloneNode.style.position = "fixed";
    cloneNode.style.top = cursorY - diff.y;
  }

  // Identify the element below the current cursor position
  const elemBelow = document.elementFromPoint(cursorX, cursorY);

  // If none exists, stop here
  if (!elemBelow) {
    return;
  }

  // Remove any current faded effects on viewports
  // Hack !!
  const viewerViewportNode = document.getElementById("imageViewerViewports");
  const viewerviewport = ReactDOM.findDOMNode(viewerViewportNode);
  const canvasNodes = viewerviewport.querySelectorAll("canvas");
  canvasNodes.forEach((element) => {
    element.classList.remove("faded");
  });

  // Figure out what to do depending on what we're dragging over
  //const viewportsDraggedOver = getParents(elemBelow, '.viewportContainer');// elemBelowNode.parents('.viewportContainer');
  const viewportsDraggedOver = Helper.DomHelper.getParents(
    elemBelow,
    "viewportContainer"
  ); // elemBelowNode.parents('.viewportContainer');

  // 이부분에 관해선 추후 적절한 방법으로 수정 필요
  if (object !== null && object !== undefined) {
    object.isMouseDragging = true;
  }

  if (viewportsDraggedOver.length) {
    // If we're dragging over a non-empty viewport, fade it and change the cursor style

    viewportsDraggedOver.forEach((element) => {
      const canvases = element.querySelectorAll("canvas:not(.magnifyTool)");

      canvases.forEach((element) => {
        element.classList.add("faded");
      });
    });

    document.body.style.cursor = "copy";
  } else if (
    elemBelow.classList.contains("viewportContainer") &&
    elemBelow.classList.contains("empty")
  ) {
    // If we're dragging over an empty viewport, just change the cursor style
    document.body.style.cursor = "copy";
  } else {
    // Otherwise, keep the cursor as no-drop style
    document.body.style.cursor = "no-drop";
  }
};
/**
 *
 *
 * @param {*} event
 * @param {*} data
 * @param {*} handlers
 * @returns
 */
const thumbnailDragEndHandler = (
  event,
  data,
  handlers = null,
  object = null
) => {
  // 이부분에 관해선 추후 적절한 방법으로 수정 필요
  if (object !== null && object !== undefined) {
    //object.isMouseMoving = false;
    object.isMouseDragging = false;
  }

  // Remove the mouse event listeners
  if (handlers) {
    document.removeEventListener("mousemove", handlers.mousemove);
    document.removeEventListener("mouseup", handlers.mouseup);
  }
  // Get the touch/mouse coordinates from the event
  let cursorX;
  let cursorY;
  if (event.type === "touchend") {
    cursorX = event.changedTouches[0].pageX;
    cursorY = event.changedTouches[0].pageY;
  } else {
    cursorX = event.pageX;
    cursorY = event.pageY;
  }

  // Reset the cursor style to the default
  document.body.style.cursor = "auto";

  // Get the cloned element
  const cloneNodes = document.querySelectorAll("#DragClone");

  // If it doesn't exist, stop here
  if (!cloneNodes.length) {
    return;
  }
  //const cloneNode = cloneNodes[0];
  const elemBelow = document.elementFromPoint(cursorX, cursorY);

  // Remove all cloned elements from the page
  //const imageThumbnailCloneNodes = document.getElementsByClassName('.imageThumbnailClone');
  const imageThumbnailCloneNodes = document.querySelectorAll(
    ".imageThumbnailClone"
  );

  imageThumbnailCloneNodes.forEach((element) => {
    element.remove();
  });

  // Remove any current faded effects on viewports
  //const viewportContainerCanvasNode = ReactDOM.findDOMNode('.viewportContainer canvas');
  // Hack !!
  const containerCanvases = document.querySelectorAll(
    ".viewportContainer canvas"
  );
  containerCanvases.forEach((element) => {
    //element.removeClass('faded');
    element.classList.remove("faded");
  });

  // If none exists, stop here
  if (!elemBelow) {
    return;
  }

  // Remove any fade effects on the element below
  elemBelow.classList.remove("faded");

  let element;
  const viewportsDraggedOver = Helper.DomHelper.closest(
    elemBelow,
    ".viewportContainer"
  );
  //const viewportsDraggedOver = elemBelowNode.closest('.viewportContainer');    //###

  if (
    viewportsDraggedOver === undefined ||
    _.has(viewportsDraggedOver, "length") === false
  ) {
    return false;
  }

  if (viewportsDraggedOver.length) {
    // If we're dragging over a non-empty viewport, retrieve it
    //element = viewportsDraggedOver.get(0);
    element = viewportsDraggedOver;
  } else if (
    elemBelow.classList.contains("viewportContainer") &&
    elemBelow.classList.contains("empty")
  ) {
    // If we're dragging over an empty viewport, retrieve that instead
    element = elemBelow;
  } else {
    // Otherwise, stop here
    return false;
  }

  // If there is no stored drag and drop data, stop here
  if (!data) {
    return false;
  }

  // Get the dropped viewport index
  const viewportContainerCanvasNode = document.querySelectorAll(
    ".viewportContainer"
  );

  var arr = Array.prototype.slice.call(viewportContainerCanvasNode); // Now it's an Array.
  const viewportIndex = arr.indexOf(element[0]);
  let viewport = element[0].querySelector(".imageViewerViewport");

  ///
  /// 드래그한 viewport에 데이터 출력 및 활성상태 변경.
  ///
  if (viewport !== null && viewport !== undefined) {
    let enabledElement = getEnabledElement(viewport);
    const metadataID = Cache.KeyGen.makeKey(
      data.seriesInstanceUID,
      data.modality
    );
    Controller.ReadyRequestDisplayData(
      viewportIndex,
      enabledElement,
      metadataID,
      0
    );
  }

  return true;
};

const thumbnailDragHandlers = {
  thumbnailDragEndHandler,
  thumbnailDragStartHandler,
  thumbnailDragHandler,
};

export { thumbnailDragHandlers };
